import _ from "lodash";

export const controllers = {
    LeadCtrl: [
        'Lead',
        'School',
        '$scope',
        function (Lead, School, $scope) {
            let $ctrl = this, _$ctrl = {watchers: []};

            _$ctrl.init = () => {
                $ctrl.school = School.getOrCreate({
                    resource_uri: `${API_URL}/school/241/`,
                    id: 241,
                    name: 'Craiova',
                    address: 'Strada Macului Nr 1 A',
                    city: 'Craiova',
                    state: 'Dolj',
                    country: 'RO',
                    email: 'craiova@englishconnection.ro',
                    phone: '+40756428463',
                });

                $ctrl.accept = false;

                _$ctrl.initLead();
            };

            _$ctrl.destroy = () => {
                _.each(_$ctrl.watchers, (watcher) => watcher());
            };

            _$ctrl.initLead = () => {
                $ctrl.lead = Lead.getOrCreate({
                    country: 'RO',
                    origin: 'IN',
                    lead_type: 'S',
                    allow_communication: false,
                    school: $ctrl.school
                });
            };

            $ctrl.test = () => {
                console.log($ctrl);
                console.log($scope);
            };

            $ctrl.submit = () => {
                if ($ctrl.lead.$validate) {
                    $ctrl.lead.$save().then(
                        () => console.log('Success'),
                        () => console.log('Failure')
                    );
                }
            };

            _$ctrl.init();
            $scope.$on('$destroy', _$ctrl.destroy);
        }
    ]
};



// WEBPACK FOOTER //
// ./scripts/controllers.js